import { Component, computed, EventEmitter, Input, Output } from '@angular/core';
import { updatedAtSignal } from '../analysis-data';
import { v3ComponentContext } from '../services/v3-component-context';
import { findV3AnalysisSignal } from '../services/v3-guest-mode';
import { CompetitionPeer } from '../competitor-analysis/competitor-analysis';
import { V3CompetitorTable } from '../v3-competitor-table/v3-competitor-table';
import { V3CompetitorHighlights } from '../v3-competitor-highlights/v3-competitor-highlights';
import { V3OverviewCardHeader } from '../v3-overview-card-header/v3-overview-card-header';

// V3's main-page "Wettbewerb" card — restyles V2's CompetitorAnalysis summary. See CLAUDE.md.
@Component({
  selector: 'app-v3-competitor-overview',
  imports: [V3CompetitorTable, V3CompetitorHighlights, V3OverviewCardHeader],
  standalone: true,
  templateUrl: './v3-competitor-overview.html',
  styleUrl: './v3-competitor-overview.scss',
})
export class V3CompetitorOverview {
  private readonly ctx = v3ComponentContext();

  /** Live EUR price per ISIN, for V3CompetitorTable. */
  @Input() livePrices: Record<string, number> | null = null;
  @Output() navigate = new EventEmitter<void>();
  @Output() navigateToInstrument = new EventEmitter<string>();

  readonly isZeroDesktop = this.ctx.layout.isZeroDesktop;
  readonly isFinnetDesktop = this.ctx.layout.isFinnetDesktop;
  readonly isFinnet = this.ctx.layout.isFinnet;
  readonly isDesktop = this.ctx.layout.isDesktop;

  private readonly isGuestMode = this.ctx.isGuestMode;

  private readonly competitionAnalysis = findV3AnalysisSignal(
    this.ctx.assetsStore.v2Data,
    'competition',
    this.isGuestMode,
  );

  readonly visible = computed(() => !!this.competitionAnalysis());

  readonly advantage = computed(
    () => (this.competitionAnalysis()?.content?.['advantage'] as string | null) ?? null,
  );
  readonly risk = computed(
    () => (this.competitionAnalysis()?.content?.['risk'] as string | null) ?? null,
  );

  // No subject row here — see V3CompetitorAnalysis; restricted entries filtered out.
  readonly peers = computed<CompetitionPeer[]>(() => {
    const raw = this.competitionAnalysis()?.content?.['peers'];
    if (!Array.isArray(raw)) return [];
    return (raw as (CompetitionPeer & { restricted?: boolean })[]).filter((p) => !p.restricted);
  });

  readonly updatedAt = updatedAtSignal(this.competitionAnalysis);

  onNavigate() {
    this.navigate.emit();
  }
}
